import { render, staticRenderFns } from "./CPanelHostingWizard.vue?vue&type=template&id=3be40ca7&"
import script from "./CPanelHostingWizard.vue?vue&type=script&lang=js&"
export * from "./CPanelHostingWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports